<template>
  <Layout>
    <div class="future-all-wrapper">
      <div class="future-flex-wrapper" v-if="companies.length > 0">
        <q-btn
          @click="!loading ? (selected = 'all') : ''"
          :color="selected === 'all' ? 'primary' : 'secondary'"
          :outline="selected !== 'all'"
          label="ALL COMPANIES"
        >
        </q-btn>
        <q-btn
          @click="!loading ? (selected = company.id) : ''"
          v-for="company in companies"
          :key="company.id"
          :color="selected === company.id ? 'primary' : 'secondary'"
          :outline="selected !== company.id"
          :label="company.name"
        >
        </q-btn>
      </div>

      <div class="rest-wrapper">
        <div v-if="!loading && companies.length > 0">
          <!-- provider
          <div style="max-width: 200px; background: #fff; margin-bottom: 10px">
            <q-select
              label="Select Provider"
              v-model="provider"
              outlined
              :option-label="(pro) => pro.name"
              :option-value="(pro) => pro.key"
              :options="providers"
              label-color="grey-7"
              color="grey-7"
              dense
            >
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="provider"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="provider = ''"
                />
              </template>
            </q-select>
          </div> -->
          <summary-chart
            :title="totalBinder"
            :items="totalItems"
          ></summary-chart>
          <div class="rest-location-wrapper">
            <div
              v-for="location in selectedCompany.locations"
              :key="location.id"
            >
              <summary-chart
                :subtitle="location.monthly_depreciation_assumption"
                :colors="colors"
                :title="location.name"
                :items="locationTotalsBinder(location)"
              ></summary-chart>
            </div>
          </div>
        </div>
        <div
          class="loading-infinite"
          :style="loading ? 'padding:25px' : ''"
          v-if="loading"
        >
          <div>
            <q-spinner-facebook color="primary" size="40px" />
            <div class="text-grey-7">Loading</div>
          </div>
        </div>
      </div>
    </div>
    <q-card
      style="width: 100%; padding: 15px"
      v-if="companies.length == 0 && !loading"
    >
      <empty-value name="company"></empty-value>
    </q-card>
  </Layout>
</template>

<script>
import axios from "../axios";
import Layout from "../components/Layout";
import EmptyValue from "../components/EmptyValue";
import SummaryChart from "../components/summary/SummaryChart";
import {defaultStatusValues} from "@/enums";
export default {
  components: {
    EmptyValue,
    SummaryChart,
    Layout,
  },
  metaInfo() {
    return {
      title: `Management summary report of total fleet’s future values | FMS`,
      meta: [
        {
          name: "description",
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content: "Management summary report of total fleet’s future values",
        },
        {
          property: "og:title",
          content: `Management summary report of total fleet’s future values | FMS`,
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  data() {
    return {
      providers: [
        // { name: "JD Power", key: "jd_power" },
        { name: "Manheim", key: "manheim" },
      ],
      provider: "",
      colors: ["#003f5c", "#ff6361", "#ffdd00"],
      selectedCompany: [],
      totalItems: [],
      companies: [],
      selected: "all",
      loading: false,
    };
  },
  async mounted() {
    try {
      this.loading = true;
      await this.getFutureSummary();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async simulationOfSummary(id) {
      this.totalItems = [];
      if (id === "all") await this.getFutureSummary();
      else {
        this.selectedCompany = await this.companies.find(
          (c) => c.id === this.selected
        );
        const { current, months } = this.selectedCompany.total;
        this.totalItems = await [].concat(current).concat(months);
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    async getFutureSummary() {
      const params = {
        provider: this.provider.key,
        statuses: defaultStatusValues
      };
      const { data } = await axios.post(
        "vehicle-analysis/future-summary-values",
        null,
        {
          params,
        }
      );
      const { companies, total } = data.data;
      this.loading = false;
      this.companies = companies;
      const { current, months } = total;
      this.totalItems = [].concat(current).concat(months);
    },
  },
  computed: {
    locationTotalsBinder() {
      return (location) => {
        if (!location) return [];
        const { current, months } = location;
        return [].concat(current).concat(months);
      };
    },
    totalBinder() {
      if (this.selected === "all")
        return `Total Of All Companies Fleet's Future Valuation`;
      else
        return `Totals Of ${
          this.companies.find((c) => c.id === this.selected).name
        } Fleet's Future Valuation`;
    },
  },
  watch: {
    selected(n, o) {
      this.selectedCompany = [];
      this.loading = true;
      this.simulationOfSummary(n);
    },
    provider: {
      deep: true,
      handler() {
        this.selectedCompany = [];
        this.loading = true;
        this.totalItems = [];
        this.selected === "all"
          ? this.getFutureSummary()
          : (this.selected = "all");
      },
    },
  },
};
</script>

<style lang="scss">
.rest-location-wrapper {
  display: flex;
  flex-flow: row wrap;
  flex: 1;
  margin-top: 10px;
  justify-content: space-between;
  div {
    margin: 5px 0px;
    flex: 0 1 calc(50% - 10px);
    width: calc(50% - 10px);
    div {
      width: calc(100%);
    }
  }
}
.active-future {
  background: radial-gradient(circle, #35a2ff 0%, #014a88 100%) !important;
}
.future-flex-wrapper {
  display: flex;
  flex-flow: column nowrap;
  flex: 0 0 200px;
  button {
    margin: 0px 5px;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    cursor: pointer;
    height: 150px;
    border: 1px solid #ccc;
  }
}
.future-all-wrapper {
  display: flex;
  flex-flow: row nowrap;
  flex: 1;
}
.rest-wrapper {
  margin-left: 10px;
  margin: 0 auto;
  width: calc(100% - 210px);
}

@media only screen and (max-width: 1024px) {
  .future-all-wrapper {
    flex-flow: column nowrap;
    div {
      margin: 5px 0px !important;
    }
  }
  .rest-wrapper {
    width: 100% !important;
  }
  .rest-location-wrapper {
    div {
      flex: 1 !important;
      width: 100%;
    }
  }
}
</style>
